import React from 'react';
import './AppInstall.css';

function AppInstall() {
  const handleInstallClick = () => {
    window.location.href = 'https://apps.apple.com/jp/app/id6746715581';
  };

  return (
    <div className="app-install-container">
      <div className="app-install-content">
        <div className="app-logo">
          <img src="/images/logo.svg" alt="Mahoroba App" />
        </div>
        <h1 className="app-title">Mahoroba</h1>
        <p className="app-description">アプリをダウンロードして<br/>続きをお楽しみください</p>
        <button className="install-button" onClick={handleInstallClick}>
          <img src="/images/app_install.svg" alt="App Storeからダウンロード" />
        </button>
      </div>
    </div>
  );
}

export default AppInstall;